import Vue from "vue";
import axios from "axios";
import router from "../router";
import {
    Toast
} from 'vant';

export function request(config, option) {
    const instance = axios.create({
        baseURL: Vue.prototype.BASE.API_URL,
        timeout: 60000
    })

    instance.interceptors.request.use(config => {
        // var cs_arr = config.data.split('&'); //参数字符串分割为数组
        // var cs = {};
        // for (var i = 0; i < cs_arr.length; i++) { //遍历数组，拿到json对象
        //     cs[cs_arr[i].split('=')[0]] = cs_arr[i].split('=')[1]
        // }
        // var toast = option.toast; //这样就拿到了参数中的数据
        // var name = option.toastName ? option.toastName : '';
        // if (toast) {
        //     Toast.loading({
        //         message: name,
        //         forbidClick: true,
        //         loadingType: 'spinner',
        //         duration: 0,
        //         className: "checkToast"
        //     });
        // }

        const token = window.localStorage.getItem('user_token')
        if (token) {
            config.headers.Authorization = token;
            // config.headers.Authorization = "7j4dzzocce3m0kt1l4p0c5vdjyskh6zs"
        }
        // config.headers.Authorization = "23d61b611da749068e78ebe007af05b0"
        return config
    }, err => {

    })

    instance.interceptors.response.use(res => {
        // Toast.clear();
        const {
            status
        } = res.data;
        if (status == 700) {
            localStorage.removeItem('user_token');
            localStorage.removeItem('user_type');
            // var local = window.location.href;
            window.sessionStorage.setItem("skipAddress", encodeURIComponent(window.location.href))
            Toast.fail({
                message: '登录已失效,请重新登录',
                duration: 1000,
                onClose() {
                    // window.location.href = `${ Vue.prototype.BASE.WECHAT_AUTHORIZE_URL}?returnUrl=${local}`;
                    // window.location.href = Vue.prototype.BASE.BASE_URL + '/login'
                    router.push('/login');
                }
            });

        } else {

            return res.data
        }
        // return res.data
    }, err => {

    })

    return instance(config)
}